import React from 'react';
import { Spinner } from 'react-bootstrap';

const AppLoader = ({ theme }: { theme: string }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: theme === 'dark' ? '#0b1727' : '#f9fafd',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        transition: 'opacity 0.5s ease-in-out'
      }}
    >
      <div className="text-center">
        <div 
          className="mb-4 pulse-animation"
          style={{
            fontSize: '2.5rem',
            fontWeight: 'bold',
            color: '#E5780B'
          }}
        >
          AddressBox
        </div>
        <Spinner 
          animation="border" 
          variant="primary" 
          style={{ width: '3rem', height: '3rem' }} 
        />
        <p 
          className="mt-3" 
          style={{ 
            color: theme === 'dark' ? '#8ba2c4' : '#5e6e82',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            fontSize: '0.8rem'
          }}
        >
          Initializing Admin Panel...
        </p>
      </div>
      <style>{`
        .pulse-animation {
          animation: pulse 2s infinite;
        }
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.8; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default AppLoader;
